"use strict";

/** Animations */
(() => {
	const imp = async (exported) => {
		const go = (imported) => imported.then((a) => a[exported]);
		switch (exported) {
			case "animate":
				return await go(import("./motion/animate"));
			case "inView":
				return await go(import("./motion/in-view"));
			case "spring":
				return await go(import("./motion/spring"));
			case "scroll":
				return await go(import("./motion/scroll"));
			case "ScrollOffset":
				return await go(import("./motion/scroll-offset"));
			default:
				return null;
		}
	};

	const init_animations = (attribute) => {
		const go = (element) => {
			const callback = element.dataset[`${attribute}`];
			if (callback) {
				const ancestor_matches = ({ ancestor, matches, callback }) => {
					const ancestor_element = element.closest(ancestor);
					if (ancestor_element) {
						new MutationObserver((mutations) =>
							mutations.forEach(() => {
								if (ancestor_element.matches(matches)) {
									callback();
								}
							})
						).observe(ancestor_element, { attributes: true });
					}
				};
				Function(
					"args",
					`"use strict"; const { ancestor_matches, element, imp } = args; (${callback.trim()})(element);`
				)({ ancestor_matches, element, imp });
			}
		};
		new MutationObserver((mutations) =>
			mutations.forEach((mutation) => {
				if (mutation.type === "childList") {
					mutation.addedNodes.forEach((node) => {
						if (node.nodeType === 1 && node.hasAttribute(`data-${attribute}`)) {
							go(node);
						}
					});
				}
			})
		).observe(document.body, { childList: true, subtree: true });
		document.querySelectorAll(`*[data-${attribute}]`).forEach(go);
	};

	init_animations("animate");
})();

/** Burger menu. */
(() => {
	const html = document.querySelector("html");
	if (html !== null) {
		((burger) => {
			if (burger !== null) {
				burger.addEventListener("click", (_) => {
					html.classList.toggle("header-burger-active");
				});
			}
		})(document.querySelector("#header-burger"));
		((not_burger) => {
			if (not_burger !== null) {
				not_burger.addEventListener("click", (_) => {
					html.classList.remove("header-burger-active");
				});
			}
		})(document.querySelector("#header-lightbox"));
	}
})();

/** Hide on scroll. */
(() => {
	const breakpoint = 1024,
		header_height = 46 + 26 * 2,
		header_height_desktop = 46 + 46 * 2,
		header = document.querySelector("#site-header");
	if (header !== null) {
		let scroll_y = window.scrollY;
		window.addEventListener("scroll", (_) => {
			if (window.scrollY > scroll_y && window.scrollY > (window.screen.width < breakpoint ? header_height : header_height_desktop)) {
				header.classList.add("hide");
			} else {
				header.classList.remove("hide");
			}
			scroll_y = window.scrollY;
		});
	}
})();
